import React from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ModernHome from "./components/ModernHome";
import Category from "./pages/Category";
import NewsDetail from "./pages/NewsDetail";
import Navbar from "./Navbar/Navbar";
import useToggle from "./Hooks/useToggle";
import AboutUs from "./pages/AboutUs";
import Privacy from "./pages/PrivacyPolicy";
import NotFound from "./pages/NotFound";
import Contact from "./pages/Contact";
import SearchResults from "./pages/SearchResults";
function App() {
  const [setShowSearch] = useToggle(false);

  return (
    <HelmetProvider>
      <div className="App">
        <Navbar searchAction={setShowSearch.toggle} />
        <Routes>
          <Route path="/" element={<ModernHome />} />
          {/* News Detail Route */}
          <Route path="/news/:id" element={<NewsDetail />} />
          {/* Category Routes - Consistent Pattern */}
          <Route path="/category/lajme" element={<Category />} />
          <Route path="/category/sport" element={<Category />} />
          <Route path="/category/teknologji" element={<Category />} />
          <Route path="/category/politikë" element={<Category />} />
          <Route path="/category/ekonomi" element={<Category />} />
          <Route path="/category/shëndetësi" element={<Category />} />{" "}
          <Route path="/category/kulturë" element={<Category />} />
          <Route path="/category/lifestyle" element={<Category />} />
          <Route path="/category/entertainment" element={<Category />} />
          <Route path="/category/nature" element={<Category />} />
          <Route path="/category/cuisine" element={<Category />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/search" element={<SearchResults />} />
          {/* <Route path="/terms" element={<TermsOfUse />} /> */}
          {/* 404 Route - Must be last */}
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </HelmetProvider>
  );
}

export default App;
